<template>
  <v-container>
    <p class="grey--text text--lighten-2">Nuria Daviu es el resultado del recorrido de tres generaciones enamoradas de su profesión.</p>
    <p class="grey--text text--lighten-2">Pasión, dedicación, vocación y formación continua es nuestro secreto.</p>
    <p class="grey--text text--lighten-2">Desde 1950 nos dedicamos a la imagen personal, pasarelas, catálogos y eventos relacionados con la moda y la alta peluquería con grandes estándares de calidad.</p>
    <p class="grey--text text--lighten-2">Conocer las preferencias del cliente nos permite personalizar con detalle cada trabajo.</p>
    <Waterfall :options="options">
      <WaterfallItem v-for="(item, index) in images" :key="index" class="col-6 col-sm-4 item pa-1">
        <img  @click="openImg(index,$event)" :src="item.src"/>
      </WaterfallItem>
    </Waterfall>
    <ImageDialog :modalIsVisible="modalIsVisible" :modalContent="modalContent" :images="images" 
      :selectedIndex="selectedIndex" @closedialog="modalIsVisible = false"/> 
  </v-container>
</template>

<script>
  import {Waterfall, WaterfallItem} from 'vue2-waterfall';
  import ImageDialog from '@/components/ImageDialog';
  export default {
    name: 'Home',
    components: { 
      Waterfall,
      WaterfallItem,
      ImageDialog
    },
    data: () => ({
      images: [],
      options: {gutter:0},
      modalIsVisible: false,
      modalContent: "",
      selectedIndex: 0,
    }),
    mounted() {
        this.importAll(require.context('../assets/carrousel/', true, /\.jpg$/));
    },
    methods: {
      importAll(r) {
        r.keys().forEach(key => (this.images.push({ src: r(key), name: key })));
      },
      openImg(index,event) {
        event.preventDefault();
        this.selectedIndex = index;
        this.modalContent = event.target.src;
        this.modalIsVisible = true;
      },
    },
  }
</script>
